let macShiftAltKey2Text = new Map()
macShiftAltKey2Text.set("a", "Å")
macShiftAltKey2Text.set("b", "ı")
macShiftAltKey2Text.set("c", "Ç")
macShiftAltKey2Text.set("d", "Î")
macShiftAltKey2Text.set("e", "´")
macShiftAltKey2Text.set("f", "Ï")
macShiftAltKey2Text.set("g", "˝")
macShiftAltKey2Text.set("h", "Ó")
macShiftAltKey2Text.set("i", "ˆ")
macShiftAltKey2Text.set("j", "Ô")
macShiftAltKey2Text.set("k", "")
macShiftAltKey2Text.set("l", "Ò")
macShiftAltKey2Text.set("m", "Â")
macShiftAltKey2Text.set("n", "˜")
macShiftAltKey2Text.set("o", "Ø")
macShiftAltKey2Text.set("p", "∏")
macShiftAltKey2Text.set("q", "Œ")
macShiftAltKey2Text.set("r", "‰")
macShiftAltKey2Text.set("s", "Í")
macShiftAltKey2Text.set("t", "ˇ")
macShiftAltKey2Text.set("u", "¨")
macShiftAltKey2Text.set("v", "◊")
macShiftAltKey2Text.set("w", "„")
macShiftAltKey2Text.set("x", "˛")
macShiftAltKey2Text.set("y", "Á")
macShiftAltKey2Text.set("z", "¸")
macShiftAltKey2Text.set("0", "‚")
macShiftAltKey2Text.set("1", "⁄")
macShiftAltKey2Text.set("2", "€")
macShiftAltKey2Text.set("3", "‹")
macShiftAltKey2Text.set("4", "›")
macShiftAltKey2Text.set("5", "ﬁ")
macShiftAltKey2Text.set("6", "ﬂ")
macShiftAltKey2Text.set("7", "‡")
macShiftAltKey2Text.set("8", "°")
macShiftAltKey2Text.set("9", "·")
macShiftAltKey2Text.set("+", "±")
macShiftAltKey2Text.set("-", "—")
macShiftAltKey2Text.set("[", "”")
macShiftAltKey2Text.set("]", "’")
macShiftAltKey2Text.set("\\", "»")
macShiftAltKey2Text.set(";", "Ú")
macShiftAltKey2Text.set("'", "Æ")
macShiftAltKey2Text.set(",", "¯")
macShiftAltKey2Text.set(".", "˘")
macShiftAltKey2Text.set("/", "let")

let macShiftAltText2Key = new Map()
macShiftAltText2Key.set("Å", "a")
macShiftAltText2Key.set("ı", "b")
macShiftAltText2Key.set("Ç", "c")
macShiftAltText2Key.set("Î", "d")
macShiftAltText2Key.set("´", "e")
macShiftAltText2Key.set("Ï", "f")
macShiftAltText2Key.set("˝", "g")
macShiftAltText2Key.set("Ó", "h")
macShiftAltText2Key.set("ˆ", "i")
macShiftAltText2Key.set("Ô", "j")
macShiftAltText2Key.set("", "k")
macShiftAltText2Key.set("Ò", "l")
macShiftAltText2Key.set("Â", "m")
macShiftAltText2Key.set("˜", "n")
macShiftAltText2Key.set("Ø", "o")
macShiftAltText2Key.set("∏", "p")
macShiftAltText2Key.set("Œ", "q")
macShiftAltText2Key.set("‰", "r")
macShiftAltText2Key.set("Í", "s")
macShiftAltText2Key.set("ˇ", "t")
macShiftAltText2Key.set("¨", "u")
macShiftAltText2Key.set("◊", "v")
macShiftAltText2Key.set("„", "w")
macShiftAltText2Key.set("˛", "x")
macShiftAltText2Key.set("Á", "y")
macShiftAltText2Key.set("¸", "z")
macShiftAltText2Key.set("‚", "0")
macShiftAltText2Key.set("⁄", "1")
macShiftAltText2Key.set("€", "2")
macShiftAltText2Key.set("‹", "3")
macShiftAltText2Key.set("›", "4")
macShiftAltText2Key.set("ﬁ", "5")
macShiftAltText2Key.set("ﬂ", "6")
macShiftAltText2Key.set("‡", "7")
macShiftAltText2Key.set("°", "8")
macShiftAltText2Key.set("·", "9")
macShiftAltText2Key.set("±", "+")
macShiftAltText2Key.set("—", "-")
macShiftAltText2Key.set("”", "[")
macShiftAltText2Key.set("’", "]")
macShiftAltText2Key.set("»", "\\")
macShiftAltText2Key.set("Ú", ";")
macShiftAltText2Key.set("Æ", "'")
macShiftAltText2Key.set("¯", ",")
macShiftAltText2Key.set("˘", ".")
macShiftAltText2Key.set("let", "/")

function getKey(text) {
    return macShiftAltText2Key.has(text) ? macShiftAltText2Key.get(text) : text
}
function getText(key) {
    return macShiftAltKey2Text.has(key) ? macShiftAltKey2Text.get(key) : key
}

export default {
    getKey,
    getText,
    macShiftAltText2Key,
    macShiftAltKey2Text,
}
